import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { WelcomeForm } from '../../components'
import { InternIDBadge } from '../../components/InternIDDisplay'


const HomePage = () => {
  const location = useLocation()
  const fromSignup = location.state
  const [showAnimation, setShowAnimation] = useState(false);
  const [showForm, setShowForm] = useState(false);

  // const fromSignup = location.state?.fromSignup;
  useEffect(() => {
    if (fromSignup) {
      setShowAnimation(true);
      // After animation, show the form
      setTimeout(() => {
        setShowAnimation(false);
        setShowForm(true);
      }, 3000); // 3 seconds for animation
    }
  }, [fromSignup]);

  return (
    <div>
      {/* Show Animation if `fromSignup` and `showAnimation` are true */}
      {fromSignup && showAnimation && (
        <div className="flex flex-col items-center justify-center h-screen w-screen bg-orange-500 text-white">
          <h1 className="text-8xl  text-center font-bold animate-bounce">Welcome to Oodles Internships!</h1>
          <p className="text-xl mt-2">We're excited to have you here!</p>
        </div>
      )}

      {/* Show Welcome Form if `fromSignup` and `showForm` are true */}
      {fromSignup && showForm && <WelcomeForm />}

      {/* Render an empty div if no conditions are met */}
      {!fromSignup && (
        <div>
        </div>
      )}
    </div>
  );
};

export default HomePage